import * as React from "react";
import EventDetails from "security-app/components/SecurityEvents/Alerts/EventDetails";
import useNonDisplayedAttributes from "components/events/events/hooks/useNonDisplayedAttributes";
function ExpandedEventDetails({ securityEvent, defaultLayout, interactiveTags = true }) {
  const nonDisplayedAttributes = useNonDisplayedAttributes(defaultLayout);
  return /* @__PURE__ */ React.createElement(
    EventDetails,
    {
      securityEventId: securityEvent.event_id,
      detailsAttributes: nonDisplayedAttributes,
      interactiveTags
    }
  );
}
export default ExpandedEventDetails;
